<div class="response-container">
  <div class="header">
    <span i18n="@@thankYouForYourOrder">Thank you for your order!</span>
  </div>
  <div  class="content">
    <div class="required-text">
      <span i18n="@@weHaveReceivedYourOrder">We have received your order and will process it as soon as possible.</span>
    </div>
    <div class="info-container">
      <div class="customer-info">
        <div class="title"><span i18n="@@requestedBy">Requested By</span></div>
        <div class="info">
          <span>{{userName}}</span>
        </div>
      </div>
      <div class="customer-info">
        <div class="title"><span i18n="@@customerName">Customer Name</span></div>
        <div class="info">
          <span>{{accountName}}</span>
        </div>
      </div>
      <div class="customer-info">
        <div class="title"><span i18n="@@accountNumber">Account Number</span></div>
        <div class="info">
          <span>{{accountNumber}}</span>
        </div>
      </div>
      <div class="customer-info">
        <div class="title"><span i18n="@@location">Location</span></div>
        <div class="info">
          <span>{{location}}</span>
        </div>
      </div>
      <div class="customer-info">
        <div class="title"><span i18n="@@product">Product</span></div>
        <div class="info">
          <span>{{product}}</span>
        </div>
      </div>
      <div class="customer-info">
        <div class="title"><span i18n="@@currentTankLevelPercent">Current Tank Level</span><span> (%)</span></div>
        <div class="info">
          <span>{{currentTankLevel}}</span>
        </div>
      </div>
      <div class="customer-info">
        <div class="title"><span i18n="@@deliveryInstructions">Delivery Instructions</span></div>
        <div class="info">
          <span>{{deliveryInstructions == '' ? '-' : deliveryInstructions}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <avenir-button [size]="BUTTON_SIZE.MEDIUM" [theme]="BUTTON_THEME.GREY" [label]="btnCloseLabel"
      (onClick)="modalService.dismissAll()">
    </avenir-button>
  </div>
</div>